const pendoAnalyticsService = {
    initializePendoAnalytics(targetWindow?: Window): void {
        if (window?.isStudent) {
            return;
        }
        if (!window?.pendo) {
            console.warn('Pendo Analytics Object not available. Verify that MPP is turned ON');
            return;
        }
        const isPendoIntegrationEnabled = window.marketplaceProperties.ENABLE_PENDO_INTEGRATION;
        const isPendoAnalyticsEnabled = window.marketplaceProperties.ENABLE_PENDO_ANALYTICS;
        const isPendoAnonymousVisitorEnabled = window.marketplaceProperties.ENABLE_PENDO_ANONYMOUS_VISITOR;
        const pendo = targetWindow && targetWindow.pendo ? targetWindow.pendo : window.pendo;
        pendo.initialize({
            visitor: {
                id: isPendoAnonymousVisitorEnabled ? `anonymous_user_${window.marketplaceId}` : window.userId,
            },
            account: {
                id: window.marketplaceId,
                marketplaceName: window.marketplaceName,
            },
            excludeNonGuideAnalytics: !(isPendoIntegrationEnabled && isPendoAnalyticsEnabled),
        });
        console.log('Pendo Analytics Initialized Successfully');
    },
};

export default pendoAnalyticsService;
